module.exports = __webpack_public_path__ + "static/media/zira.a1385ebd.png";